module.exports = {"appId":"fulfillment","appUrl":"scanshipco.com","appVersion":"api","useSSL":true,"currentVersion":""}


//////////////////
// WEBPACK FOOTER
// ./src/config/production/application-settings.json
// module id = 3865
// module chunks = 1